import * as types from "./accountsActionType";
import api from "./accountsApi";

export function updateProvinces(model, data, customHeaders) {
  return {
    type: types.UPDATE_PROVINCES,
    model,
    promise: api.updateProvinces(model, data, customHeaders),
  };
}
export function updateAccountBusinessUnit(model, data, customHeaders) {
  return {
    type: types.UPDATE_BUSINESS_ACCOUNTS,
    model,
    promise: api.updateAccountBusinessUnit(model, data, customHeaders),
  };
}

export function getAccounts(customHeaders) {
  return {
    type: types.GET_ACCOUNTS,
    promise: api.getAccounts(customHeaders),
  };
}

export function updateAccounts(model, data, customHeaders) {
  return {
    type: types.UPDATE_ACCOUNTS,
    model,
    promise: api.updateAccounts(model, data, customHeaders),
  };
}



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/accounts/accountsAction.js